import { ActionTree } from "vuex";
import { baseApi } from "@/config/http-common";
import { IRootState } from "@/store";
import { IReportState } from "@/store/modules/report/state";
import { ReportMutations } from "@/store/modules/report/mutations";

export enum ReportActions {
  FETCH_DATA_PROVIDER = "FETCH_DATA_PROVIDER_REPORT_TEMPLATE",
}

export const actions: ActionTree<IReportState, IRootState> = {
  async [ReportActions.FETCH_DATA_PROVIDER]({ commit }, params) {
    try {
      const result = await baseApi.get("/reports/report/list", {
        params: params,
      });
      commit(ReportMutations.SET_LAZY_DATA, result.data.data);
    } catch (error) {
      console.log("fetch job data provider error: ", error);
    }
  },
};
